import { render, staticRenderFns } from "./xinstitucion.vue?vue&type=template&id=37402350&scoped=true"
import script from "./xinstitucion.vue?vue&type=script&lang=js"
export * from "./xinstitucion.vue?vue&type=script&lang=js"
import style0 from "./xinstitucion.vue?vue&type=style&index=0&id=37402350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37402350",
  null
  
)

export default component.exports